import CoinCard from "../CoinCard";
import "./coins.scss";

import React, { useEffect, useState } from "react";
import moment from "jalali-moment";

import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Scrollbar, A11y } from "swiper/modules";

// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";

import PrevButton from "../../assets/icons/left-icon.png";
import NextButton from "../../assets/icons/right-icon.png";
import coinIcon from "../../assets/icons/coin.png";
import Spinner from "../Spinner";

const Coins = ({ coins, isLoading }) => {
  const [jalali, setJalali] = useState("");

  const sortedOtherCoins = coins.slice().sort((a, b) => a.coinId - b.coinId);

  useEffect(() => {
    moment.locale("fa", { useGregorianParser: true });
    setJalali(moment(coins[0]?.updatedAt).format("YYYY/MM/DD HH:mm"));
  }, [coins]);

  return (
    <div className="coins-rate">
      <div className="title-container">
        <div className="title">
          <img src={coinIcon} alt="coin" />
          نرخ سکه
        </div>
        <div className="latest-update">آخرین نرخ بروزرسانی : {jalali}</div>
      </div>
      {isLoading ? (
        <Spinner />
      ) : (
        <div className="coins-container">
          <div className="swiper2-prev">
            <img alt="بعدی" src={NextButton} className="" />
          </div>
          <Swiper
            modules={[Navigation, Pagination, Scrollbar, A11y]}
            spaceBetween={0}
            // pagination={{ clickable: true }}
            // scrollbar={{ draggable: true }}
            navigation={{
              prevEl: ".swiper2-prev",
              nextEl: ".swiper2-next",
            }}
            speed={600}
            slidesPerView={1}
            onSlideChange={() => {}} // Disable onSlideChange event
            onSwiper={(swiper) => swiper.slideTo(0, 0, false)} // Force slide to first position
          >
            <SwiperSlide key="slide1" className="four-grid">
              {sortedOtherCoins?.slice(0, 4).map((coin) => {
                return <CoinCard key={coin.id} coin={coin} />;
              })}
            </SwiperSlide>

            <SwiperSlide key="slide2" className="three-grid">
              {sortedOtherCoins?.slice(0, 3).map((coin) => {
                return <CoinCard key={coin.id} coin={coin} />;
              })}
            </SwiperSlide>
            <SwiperSlide key="slide3" className="three-grid">
              {sortedOtherCoins?.slice(3, 4).map((coin) => {
                return <CoinCard key={coin.id} coin={coin} />;
              })}
            </SwiperSlide>
            <SwiperSlide key="slide4" className="two-grid">
              {sortedOtherCoins?.slice(0, 2).map((coin) => {
                return <CoinCard key={coin.id} coin={coin} />;
              })}
            </SwiperSlide>
            <SwiperSlide key="slide5" className="two-grid">
              {sortedOtherCoins?.slice(2, 4).map((coin) => {
                return <CoinCard key={coin.id} coin={coin} />;
              })}
            </SwiperSlide>
            <SwiperSlide key="slide6" className="one-grid">
              {sortedOtherCoins?.slice(0, 1).map((coin) => {
                return <CoinCard key={coin.id} coin={coin} />;
              })}
            </SwiperSlide>
            <SwiperSlide key="slide7" className="one-grid">
              {sortedOtherCoins?.slice(1, 2).map((coin) => {
                return <CoinCard key={coin.id} coin={coin} />;
              })}
            </SwiperSlide>
            <SwiperSlide key="slide8" className="one-grid">
              {sortedOtherCoins?.slice(2, 3).map((coin) => {
                return <CoinCard key={coin.id} coin={coin} />;
              })}
            </SwiperSlide>
            <SwiperSlide key="slide9" className="one-grid">
              {sortedOtherCoins?.slice(3, 4).map((coin) => {
                return <CoinCard key={coin.id} coin={coin} />;
              })}
            </SwiperSlide>
          </Swiper>
          <div className="swiper2-next">
            <img alt="قبلی" src={PrevButton} className="" />
          </div>
        </div>
      )}
    </div>
  );
};

export default Coins;
